import React from "react";
import Alert from '@material-ui/lab/Alert';
import ContactUs from '../../contact/components';

export default function Unauthorized(props: { text: string, displayContactUs: boolean }) {
    return (<div>
        <Alert severity="warning">{props.text} {props.displayContactUs && <ContactUs />} </Alert>
    </div>);
}